<template>
  <div
    class="booking-wizard__loader"
    :class="sizeClass"
    :style="loaderStyle"
    role="presentation"
    aria-hidden="true"
  >
    <span class="booking-wizard__loader-glow" />
    <span class="booking-wizard__loader-orbit booking-wizard__loader-orbit--outer" />
    <span class="booking-wizard__loader-orbit booking-wizard__loader-orbit--inner" />
    <span class="booking-wizard__loader-dot" />
  </div>
</template>

<script>
export default {
  name: "BookingWizardLoader",
  props: {
    size: {
      type: String,
      default: "lg",
    },
    color: {
      type: String,
      default: "",
    },
  },
  computed: {
    sizeClass() {
      return `booking-wizard__loader--${this.size || "lg"}`;
    },
    resolvedColor() {
      return this.color || "var(--booking-button-color, #0275FF)";
    },
    loaderStyle() {
      return {
        "--booking-loader-color": this.resolvedColor,
      };
    },
  },
};
</script>

<style src="./bookingwizardloader.css"></style>
